/**
 * Copyright 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import UsersPage from "./containers/UsersPage";

export default UsersPage;
